import React from "react";
import { ButtonFirefliesIcon } from "@/assets/icons";
import { FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import cls from "./styles.module.scss";

interface MainButtonBaseProps {
  label: string;
}

interface MainButtonActionProps extends MainButtonBaseProps {
  onClick: () => void;
  href?: never;
}

interface MainButtonLinkProps extends MainButtonBaseProps {
  href: string;
  target?: React.AnchorHTMLAttributes<HTMLAnchorElement>["target"];
  rel?: string;
  onClick?: never;
}

type MainButtonProps = MainButtonActionProps | MainButtonLinkProps;

export const MainButton: React.FC<MainButtonProps> = (props) => {
  const content = (
    <FlexRow gap={8}>
      <ButtonFirefliesIcon />
      <Typography
        size="md"
        lineHeight="24px"
        color="var(--text-text-primary-inverse)"
        className={cls.text}
      >
        {props.label}
      </Typography>
    </FlexRow>
  );

  if (props.href) {
    const rel =
      props.rel ??
      (props.target === "_blank" ? "noopener noreferrer" : undefined);

    return (
      <a href={props.href} target={props.target} rel={rel} className={cls.btn}>
        {content}
      </a>
    );
  }

  return (
    <button type="button" className={cls.btn} onClick={props.onClick}>
      {content}
    </button>
  );
};
